import type { Bid } from './types';

/** Display title: the job title, else "<Channel> job <id>". */
export function bidTitle(b: Pick<Bid, 'job_title' | 'channel' | 'job_id'>): string {
  return b.job_title || `${b.channel} job ${b.job_id}`;
}

/**
 * Bid figures are channel analytics in the channel's own currency (Upwork =
 * USD) — not ledger Money (BE-ADR-091). Hourly values get a "/h" suffix.
 */
export function formatRate(
  value: string | number | null | undefined,
  currency: string,
  jobType: string,
): string {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  const amount = Number.isFinite(n) ? n.toLocaleString(undefined, { maximumFractionDigits: 2 }) : String(value);
  return `${amount} ${currency}${jobType === 'fixed' ? '' : '/h'}`;
}

export function formatBidValue(b: Pick<Bid, 'our_bid_value' | 'currency' | 'job_type'>): string {
  return formatRate(b.our_bid_value, b.currency, b.job_type);
}
